import React, { forwardRef } from 'react';

import MUICheckbox, {
  CheckboxProps as MUICheckboxProps,
} from '@material-ui/core/Checkbox';

interface CheckboxProps extends MUICheckboxProps {}

const Checkbox = forwardRef<HTMLButtonElement, CheckboxProps>((props, ref) => {
  return <MUICheckbox {...props} ref={ref} />;
});

Checkbox.displayName = 'Checkbox';

export default Checkbox;
